import { Reveal } from "@/components/motion";

// Consistent section overline + heading block
export const SectionHeading = ({
  overline,
  title,
  subtitle,
  align = "left",
  light = false,
  className = "",
}) => (
  <div
    className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} ${className}`}
  >
    {overline && (
      <Reveal>
        <div
          className={`mb-5 flex items-center gap-3 ${
            align === "center" ? "justify-center" : ""
          }`}
        >
          <span className={`h-px w-10 ${light ? "bg-cream/50" : "bg-cab/50"}`} />
          <span
            className={`font-display text-xs font-bold uppercase tracking-[0.25em] ${
              light ? "text-cream/80" : "text-cab"
            }`}
          >
            {overline}
          </span>
        </div>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2
        className={`font-display font-extrabold tracking-tight leading-[0.98] text-4xl sm:text-5xl lg:text-[3.4rem] ${
          light ? "text-cream" : "text-ink"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.12}>
        <p
          className={`mt-5 text-base md:text-lg leading-relaxed ${
            light ? "text-cream/75" : "text-muted-foreground"
          }`}
        >
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
